import { Literal, Static, Union } from "runtypes";

import { EnumValues } from "../index.js";
import { getNormalEnum } from "../runtypeEnums.js";

export const DataBrowserIdTypeLiteral = Union(
  Literal("data-connection"),
  Literal("database"),
  Literal("schema"),
  Literal("table"),
);

export type DataBrowserIdType = Static<typeof DataBrowserIdTypeLiteral>;
export const DataBrowserIdType = getNormalEnum(DataBrowserIdTypeLiteral);

export const DataBrowserSemanticIdType = {
  PROJECT: "semantic-project",
  DATASET: "semantic-model",
  VIEW: "semantic-view",
  /** @deprecated use `PROJECT` instead */
  PROJECT_DEPRECATED: "model",
} as const;
export type DataBrowserSemanticIdType = EnumValues<
  typeof DataBrowserSemanticIdType
>;

/** AKA "detail view type" route param: .../data/recommended/:detailViewType */
export const DataBrowserRecommendedIdTypeLiteral = Union(
  Literal("recently-used"),
  Literal("favorites"),
  Literal("endorsed"),
);
export type DataBrowserRecommendedIdType = Static<
  typeof DataBrowserRecommendedIdTypeLiteral
>;
export const DataBrowserRecommendedIdType = getNormalEnum(
  DataBrowserRecommendedIdTypeLiteral,
);
